class MetadataProvider {
    constructor(metadataResource) {
        this.resourceURL = `https://e4tiu28fl2.execute-api.us-west-2.amazonaws.com/prod/${metadataResource}`;
    }

    fetchMetadata(callback) {
        // construct the XMLHttpRequest object
        const xhr = new XMLHttpRequest();
        // Event listener delegates to the callback function passed in by the component
        xhr.addEventListener('load', function() {
            callback(JSON.parse(xhr.responseText));
        });
        // open the request to fetch the metadata from the resource
        xhr.open('GET', this.resourceURL)
        // send the request
        xhr.send();
    }
}

export default MetadataProvider;